"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var Input_1 = tslib_1.__importDefault(require("../Input"));
/**
 * @deprecated Use Input from @eduzz/houston-forms or Antd
 */
var Text = function (props) {
    return (0, jsx_runtime_1.jsx)(Input_1.default, tslib_1.__assign({}, props));
};
exports.default = Text;
